import React, { useState } from "react";
import { Field, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import type { ConnectionEditState, ConnectionEditStateUpdater } from "../Connections.ViewModel";
import { SourceSingleTagPicker } from "./components/SourceSingleTagPicker";
import { AGE_OPTIONS, resolveAgeLimitSelection } from "./NewTaskAgeLimitField.ViewModel";

interface NewTaskAgeLimitFieldProps {
  editingConnection: ConnectionEditState;
  onUpdate: ConnectionEditStateUpdater;
}

export const NewTaskAgeLimitField: React.FC<NewTaskAgeLimitFieldProps> = ({
  editingConnection,
  onUpdate,
}) => {
  const { t } = useTranslation();
  const [ageQuery, setAgeQuery] = useState("");
  const { selectedId, labelKey } = resolveAgeLimitSelection(
    editingConnection.newTaskDaysLimit,
  );
  const notSetLabel = t("board.connections.dialog.newTaskAgeLimit.notSet");

  return (
    <Field
      orientation="horizontal"
      label={t("board.connections.dialog.fields.newTaskDaysLimit")}
    >
      <SourceSingleTagPicker
        selectedId={selectedId}
        selectedLabel={labelKey ? t(labelKey) : undefined}
        query={ageQuery}
        placeholder={notSetLabel}
        options={AGE_OPTIONS.map((option) => ({
          id: option.value,
          label: t(option.labelKey),
        }))}
        onQueryChange={setAgeQuery}
        onSelect={(value) => {
          onUpdate({ newTaskDaysLimit: value ?? "" });
        }}
        clearSelectionText={notSetLabel}
      />
      <Text>{t("board.connections.dialog.newTaskAgeLimit.help")}</Text>
      {!selectedId && (
        <Text weight="semibold">
          {t("board.connections.dialog.newTaskAgeLimit.notSetWarning")}
        </Text>
      )}
    </Field>
  );
};
